// UserContext.js
import React, { createContext, useState, useContext } from 'react';

const selectedUserContext = createContext();

export const UserProvider = ({ children }) => {
  const [selectedUser, setSelectedUser] = useState(null);

  const selectUser = (user) => {
    setSelectedUser(user);
  };

  return (
    <selectedUserContext.Provider value={{ selectedUser, selectUser }}>
      {children}
    </selectedUserContext.Provider>
  );
};

export const UseUser = () => {
  const context = useContext(selectedUserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
